// removed by extract-text-webpack-plugin
module.exports = {"member":"IavVHY_JT_XmmXunohnrL","image":"_2paf0b0ee1KTPSjZj_G4l7","memberImage":"_1fHxap-_sNioZ-Nf5JzQhc","info":"_1UNkMA41wGIyo7afFC4jST","name":"_1E-zd8fh04fUPPMS1uehkv","title":"_2NDkXZ8e2QFgNTUsRHw7xF","text":"OmVoUGLXavado93aj5LF9","button":"BgTAyVvmss7VMnelCUJKx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BoardMember/BoardMember.module.scss
// module id = 736
// module chunks = 0